import { allBooks } from './booksData'
import { aftertideBooks } from './aftertideBooksData'

export type BookstoreType =
  | 'brick-and-mortar'
  | 'online-only'
  | 'hybrid'
  | 'pop-up'
  | 'specialty'

export interface Bookstore {
  id: string
  name: string
  slug: string
  type: BookstoreType
  logo: string
  bannerImage?: string
  description: string
  country: string
  city?: string
  address?: string
  websiteUrl: string
  socialLinks?: { platform: string; url: string }[]
  contactEmail?: string
  shippingRegions: string[]
  specializations: string[]
  features: {
    signedCopies: boolean
    hostsEvents: boolean
    indieFocused: boolean
    internationalShipping: boolean
  }
  verified: boolean
  claimed: boolean
  rating: number
  reviewCount: number
  bookCount: number
}

export interface BookstoreBookLink {
  bookstoreId: string
  bookId: string
  availabilityType: 'stocked' | 'online-listing' | 'signed-copy' | 'pre-order'
  directLinkUrl?: string
  formatAvailable: string[]
}

export const bookstores: Bookstore[] = [
  {
    id: 'store-1',
    name: 'The Bookish Fox',
    slug: 'the-bookish-fox',
    type: 'brick-and-mortar',
    logo: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=200&h=200&fit=crop',
    bannerImage:
      'https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=1200&h=400&fit=crop',
    description:
      'A cozy independent bookstore nestled in the heart of the city, specializing in romance, fantasy, and indie authors. We host weekly author events and book clubs.',
    country: 'US',
    city: 'Portland, OR',
    address: '742 Hawthorne Blvd, Portland, OR 97214',
    websiteUrl: 'https://example.com',
    socialLinks: [
      { platform: 'Instagram', url: 'https://instagram.com' },
      { platform: 'TikTok', url: 'https://tiktok.com' },
    ],
    contactEmail: 'hello@bookishfox.com',
    shippingRegions: ['US', 'Canada'],
    specializations: ['Romance', 'Fantasy', 'Indie Fiction'],
    features: {
      signedCopies: true,
      hostsEvents: true,
      indieFocused: true,
      internationalShipping: false,
    },
    verified: true,
    claimed: true,
    rating: 4.8,
    reviewCount: 124,
    bookCount: 45,
  },
  {
    id: 'store-2',
    name: 'Midnight Pages',
    slug: 'midnight-pages',
    type: 'online-only',
    logo: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=200&h=200&fit=crop',
    description:
      "Your premier online destination for dark romance, thrillers, and taboo fiction. We ship worldwide and offer exclusive signed editions you won't find anywhere else.",
    country: 'UK',
    websiteUrl: 'https://example.com',
    socialLinks: [{ platform: 'TikTok', url: 'https://tiktok.com' }],
    shippingRegions: ['Worldwide'],
    specializations: ['Dark Romance', 'Thriller', 'Horror'],
    features: {
      signedCopies: true,
      hostsEvents: false,
      indieFocused: true,
      internationalShipping: true,
    },
    verified: true,
    claimed: true,
    rating: 4.9,
    reviewCount: 342,
    bookCount: 120,
  },
  {
    id: 'store-3',
    name: 'Indie Ink Books',
    slug: 'indie-ink-books',
    type: 'hybrid',
    logo: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=200&h=200&fit=crop',
    bannerImage:
      'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1200&h=400&fit=crop',
    description:
      'Dedicated entirely to self-published and indie authors. We believe the best stories are often found outside traditional publishing.',
    country: 'Canada',
    city: 'Toronto, ON',
    address: '456 Queen St W, Toronto, ON M5V 2A8',
    websiteUrl: 'https://example.com',
    shippingRegions: ['US', 'Canada', 'UK'],
    specializations: ['Indie Fiction', 'Sci-Fi', 'Contemporary'],
    features: {
      signedCopies: false,
      hostsEvents: true,
      indieFocused: true,
      internationalShipping: true,
    },
    verified: false,
    claimed: true,
    rating: 4.6,
    reviewCount: 89,
    bookCount: 200,
  },
  {
    id: 'store-4',
    name: 'The Velvet Bookmark',
    slug: 'the-velvet-bookmark',
    type: 'specialty',
    logo: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=200&h=200&fit=crop',
    description:
      'A specialty boutique focusing on special editions, sprayed edges, and luxury book boxes for the discerning collector.',
    country: 'Australia',
    city: 'Melbourne',
    address: '88 Collins St, Melbourne VIC 3000',
    websiteUrl: 'https://example.com',
    shippingRegions: ['Worldwide'],
    specializations: ['Special Editions', 'Fantasy', 'Romance'],
    features: {
      signedCopies: true,
      hostsEvents: false,
      indieFocused: false,
      internationalShipping: true,
    },
    verified: true,
    claimed: true,
    rating: 4.9,
    reviewCount: 512,
    bookCount: 30,
  },
  {
    id: 'store-5',
    name: 'Chapter & Verse',
    slug: 'chapter-and-verse',
    type: 'brick-and-mortar',
    logo: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=200&h=200&fit=crop',
    description:
      'A community-focused bookstore with a cafe. We stock a wide variety of genres and love supporting local authors.',
    country: 'US',
    city: 'Austin, TX',
    address: '1205 S Congress Ave, Austin, TX 78704',
    websiteUrl: 'https://example.com',
    shippingRegions: ['US'],
    specializations: ['General Fiction', 'Mystery', 'Non-Fiction'],
    features: {
      signedCopies: false,
      hostsEvents: true,
      indieFocused: false,
      internationalShipping: false,
    },
    verified: false,
    claimed: false,
    rating: 4.5,
    reviewCount: 67,
    bookCount: 15,
  },
  {
    id: 'store-6',
    name: 'Dark Editions',
    slug: 'dark-editions',
    type: 'online-only',
    logo: 'https://images.unsplash.com/photo-1614113489855-66422ad300a4?w=200&h=200&fit=crop',
    bannerImage:
      'https://images.unsplash.com/photo-1505664194779-8beaceb93744?w=1200&h=400&fit=crop',
    description:
      'Curating the finest in dark romance, monster romance, and taboo fiction. We partner directly with authors for exclusive covers.',
    country: 'US',
    websiteUrl: 'https://example.com',
    shippingRegions: ['Worldwide'],
    specializations: ['Dark Romance', 'Monster Romance', 'Paranormal'],
    features: {
      signedCopies: true,
      hostsEvents: false,
      indieFocused: true,
      internationalShipping: true,
    },
    verified: true,
    claimed: true,
    rating: 4.7,
    reviewCount: 215,
    bookCount: 85,
  },
  {
    id: 'store-7',
    name: 'Wanderlust Books',
    slug: 'wanderlust-books',
    type: 'pop-up',
    logo: 'https://images.unsplash.com/photo-1526243741027-444d633d7365?w=200&h=200&fit=crop',
    description:
      'A traveling bookstore that pops up at conventions, book fairs, and author signing events across Europe.',
    country: 'Germany',
    city: 'Berlin',
    address: '12 Friedrichstraße, Berlin 10117',
    websiteUrl: 'https://example.com',
    shippingRegions: ['EU'],
    specializations: ['Romance', 'Fantasy', 'Young Adult'],
    features: {
      signedCopies: true,
      hostsEvents: true,
      indieFocused: true,
      internationalShipping: false,
    },
    verified: true,
    claimed: true,
    rating: 4.9,
    reviewCount: 42,
    bookCount: 60,
  },
  {
    id: 'store-8',
    name: 'The Story Keeper',
    slug: 'the-story-keeper',
    type: 'hybrid',
    logo: 'https://images.unsplash.com/photo-1476275466078-4007374efbbe?w=200&h=200&fit=crop',
    description:
      'Preserving stories of all kinds. We have a small storefront and a massive online catalog.',
    country: 'UK',
    city: 'London',
    address: '34 Charing Cross Rd, London WC2H 0DG',
    websiteUrl: 'https://example.com',
    shippingRegions: ['UK', 'EU', 'US'],
    specializations: ['Historical Fiction', 'Fantasy', 'Mystery'],
    features: {
      signedCopies: false,
      hostsEvents: false,
      indieFocused: false,
      internationalShipping: true,
    },
    verified: false,
    claimed: false,
    rating: 4.3,
    reviewCount: 18,
    bookCount: 25,
  },
]

export const bookstoreBookLinks: BookstoreBookLink[] = [
  {
    bookstoreId: 'store-1',
    bookId: '1',
    availabilityType: 'stocked',
    formatAvailable: ['paperback', 'hardcover'],
  },
  {
    bookstoreId: 'store-1',
    bookId: '2',
    availabilityType: 'signed-copy',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-1',
    bookId: '3',
    availabilityType: 'stocked',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-2',
    bookId: 'at1',
    availabilityType: 'online-listing',
    formatAvailable: ['paperback', 'ebook'],
  },
  {
    bookstoreId: 'store-2',
    bookId: 'at2',
    availabilityType: 'signed-copy',
    formatAvailable: ['hardcover'],
  },
  {
    bookstoreId: 'store-2',
    bookId: 'at3',
    availabilityType: 'pre-order',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-3',
    bookId: '4',
    availabilityType: 'stocked',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-3',
    bookId: '5',
    availabilityType: 'online-listing',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-4',
    bookId: '1',
    availabilityType: 'signed-copy',
    formatAvailable: ['hardcover'],
  },
  {
    bookstoreId: 'store-4',
    bookId: '6',
    availabilityType: 'pre-order',
    formatAvailable: ['hardcover'],
  },
  {
    bookstoreId: 'store-5',
    bookId: '7',
    availabilityType: 'stocked',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-6',
    bookId: 'at4',
    availabilityType: 'signed-copy',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-6',
    bookId: 'at5',
    availabilityType: 'online-listing',
    formatAvailable: ['paperback', 'ebook'],
  },
  {
    bookstoreId: 'store-7',
    bookId: '2',
    availabilityType: 'stocked',
    formatAvailable: ['paperback'],
  },
  {
    bookstoreId: 'store-8',
    bookId: '8',
    availabilityType: 'stocked',
    formatAvailable: ['paperback', 'hardcover'],
  },
]

export const getBookstoreBySlug = (slug: string): Bookstore | undefined => {
  return bookstores.find((store) => store.slug === slug)
}

export const getBookstoresForBook = (bookId: string): Bookstore[] => {
  const links = bookstoreBookLinks.filter((link) => link.bookId === bookId)
  const storeIds = links.map((link) => link.bookstoreId)
  return bookstores.filter((store) => storeIds.includes(store.id))
}

export const getBooksForBookstore = (bookstoreId: string) => {
  const links = bookstoreBookLinks.filter(
    (link) => link.bookstoreId === bookstoreId,
  )

  // Combine LitLaunch and AfterTide books to find matches
  const allBooksData = [
    ...allBooks,
    ...aftertideBooks.map((atBook) => ({
      id: atBook.id,
      title: atBook.title,
      author: atBook.author,
      coverImage: atBook.cover,
      rating: atBook.rating,
      reviewCount: atBook.reviewCount,
      formats: ['paperback', 'ebook'],
      genres: atBook.genres,
      spiceLevel: atBook.darknessTier,
      darknessLevel: atBook.darknessTier,
    })),
  ]

  return links
    .map((link) => {
      const book = allBooksData.find((b) => b.id === link.bookId)
      return {
        book,
        linkInfo: link,
      }
    })
    .filter((item) => item.book !== undefined)
}
